module.exports = __webpack_public_path__ + "static/logo-w-36fab3970774a59891d24da754802994.png";